const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricetracqLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 629.61 195.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 629.61,
    height: 195.58,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56,125.78h-8V81.45h7.5v5.12a13.45,13.45,0,0,1,4.53-4.38,11.9,11.9,0,0,1,5.95-1.47v8.34a11.36,11.36,0,0,0-4.48.85,8.6,8.6,0,0,0-3.22,2.34c-1.53,1.83-2.3,4.78-2.3,8.87Z",
    style: {
      fill: "#7d3cbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.26,76.25h-7.9V67.1h7.9Zm-7.9,49.53V81.45h7.9v44.33Z",
    style: {
      fill: "#7d3cbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.85,110.67q-2.78,7.92-8.24,12.08a21.35,21.35,0,0,1-13.36,4.16,23.19,23.19,0,0,1-9-1.69,20.76,20.76,0,0,1-3.81-2.09,22.65,22.65,0,0,1-3.48-3.06,25.24,25.24,0,0,1-4.88-7.57,26.86,26.86,0,0,1-1.29-4.39,22,22,0,0,1-.44-4.47A23.63,23.63,0,0,1,282.93,95a23.23,23.23,0,0,1,4.71-7.45,23.5,23.5,0,0,1,7.7-5.56,22.37,22.37,0,0,1,9.15-1.89,21.34,21.34,0,0,1,13.18,4.19,23.71,23.71,0,0,1,8.18,11.85h-8.74a14.59,14.59,0,0,0-5.38-6.09,15,15,0,0,0-7.92-2,13.2,13.2,0,0,0-10,4.47,16.71,16.71,0,0,0,0,22.09,14.38,14.38,0,0,0,18,2.27,14.66,14.66,0,0,0,5.34-6.22Z",
    style: {
      fill: "#7d3cbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.72,106.56a14.76,14.76,0,0,0,5,9,14.87,14.87,0,0,0,16.76,1.57,13.93,13.93,0,0,0,5.16-5.33h9A25,25,0,0,1,367.09,123a21.56,21.56,0,0,1-12.82,3.92,22.84,22.84,0,0,1-9-1.71,22.06,22.06,0,0,1-7.4-5.22,25.16,25.16,0,0,1-4.87-7.57,26.58,26.58,0,0,1-1.29-4.39,21.84,21.84,0,0,1-.45-4.46,23.87,23.87,0,0,1,1.58-8.7,23,23,0,0,1,4.71-7.45,21.58,21.58,0,0,1,7.48-5.48,23.3,23.3,0,0,1,19.89.89,23.23,23.23,0,0,1,8.3,7.61,20.55,20.55,0,0,1,1.66,3.13,26.66,26.66,0,0,1,1.2,3.53,33.08,33.08,0,0,1,.93,8.22v1.25Zm28.58-7.18a15.85,15.85,0,0,0-5.12-8.48,13.51,13.51,0,0,0-8.83-3,14.06,14.06,0,0,0-9.05,3A16,16,0,0,0,340,99.38Z",
    style: {
      fill: "#7d3cbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.67,125.78V88.7h-6.24V81.45h6.24V67.1h7.94V81.45h6.29V88.7h-6.29v37.08Z",
    style: {
      fill: "#7d3cbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.73,125.78h-8V81.45h7.49v5.12a13.48,13.48,0,0,1,4.54-4.38,11.84,11.84,0,0,1,5.94-1.47v8.34a11.35,11.35,0,0,0-4.47.85A8.64,8.64,0,0,0,417,92.25c-1.53,1.83-2.29,4.78-2.29,8.87Z",
    style: {
      fill: "#7d3cbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.36,125.78v-5.44a20.83,20.83,0,0,1-6.87,4.82,20.08,20.08,0,0,1-8,1.63,22.42,22.42,0,0,1-16.59-6.67,22.75,22.75,0,0,1-6.63-16.71,23.91,23.91,0,0,1,1.65-8.88,22.42,22.42,0,0,1,4.72-7.36A21.39,21.39,0,0,1,441.91,82,23.2,23.2,0,0,1,451,80.32a21.52,21.52,0,0,1,8.37,1.59,20.84,20.84,0,0,1,7,4.9V81.45h8.06v44.33Zm-29.83-22.45A15.52,15.52,0,0,0,441,114.62a14.62,14.62,0,0,0,10.9,4.55,14.15,14.15,0,0,0,10.36-4.59,14.77,14.77,0,0,0,4.51-10.68,15.63,15.63,0,0,0-4.45-11.17,14.15,14.15,0,0,0-10.58-4.67,15.14,15.14,0,0,0-15.2,15.27Z",
    style: {
      fill: "#7d3cbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.77,110.67q-2.78,7.92-8.24,12.08a21.37,21.37,0,0,1-13.36,4.16,23.15,23.15,0,0,1-9-1.69,20.13,20.13,0,0,1-3.81-2.09,22.7,22.7,0,0,1-3.49-3.06A25.41,25.41,0,0,1,483,112.5a26.86,26.86,0,0,1-1.29-4.39,22,22,0,0,1-.45-4.47A23.84,23.84,0,0,1,482.84,95a23.09,23.09,0,0,1,4.72-7.45,23.39,23.39,0,0,1,7.7-5.56,22.37,22.37,0,0,1,9.15-1.89,21.36,21.36,0,0,1,13.18,4.19,23.78,23.78,0,0,1,8.18,11.85H517a14.52,14.52,0,0,0-5.38-6.09,15,15,0,0,0-7.92-2,13.18,13.18,0,0,0-10,4.47,16.71,16.71,0,0,0,0,22.09,14.36,14.36,0,0,0,17.95,2.27,14.66,14.66,0,0,0,5.34-6.22Z",
    style: {
      fill: "#7d3cbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.71,144.47h-9.34V121.16A23.4,23.4,0,0,1,529,102.42a23.36,23.36,0,0,1,46.72,0Zm-13.45-32.14a14,14,0,1,0-9.91,4.11A13.5,13.5,0,0,0,562.26,112.33Z",
    style: {
      fill: "#7d3cbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.92,102.42a23.36,23.36,0,1,1,39.88,16.52,23.45,23.45,0,0,1-30.53,2.22v23.31h-9.35Zm23.36,14a14,14,0,1,0-9.9-4.11A13.53,13.53,0,0,0,213.28,116.44Z",
    style: {
      fill: "#7d3cbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.07,50a63.73,63.73,0,0,0-16,28.83,63.86,63.86,0,0,0-1.85,13.45h6.66c0-.57.07-1.4.15-2.4a60.52,60.52,0,0,1,4.24-17.84,57.89,57.89,0,0,1,8.12-13.79c1.26-1.6,2.41-2.87,3.26-3.78Z",
    style: {
      fill: "#504e8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.58,60.81l.43.73c1.9,3,4.4,4,7.06,1.7A63.52,63.52,0,0,1,97.16,53.07",
    style: {
      fill: "none",
      stroke: "#504e8b",
      strokeMiterlimit: 10,
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5,56.09l1.23,1.71a2.58,2.58,0,0,0,3.7.52L88.3,53.7",
    style: {
      fill: "none",
      stroke: "#504e8b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.13,75.23l7.76-13.45c1.19-2.07,2.35-4.15,3.61-6.17a1.69,1.69,0,0,1,1.28-.76q19.83,2.44,30.16,19.57c.13.22.21.46.38.81Z",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.38,114.8,124.8,77.43c.52,0,.89-.09,1.26-.09,7.07,0,14.14,0,21.21,0,.77,0,1.31.09,1.65.92,5.07,12.36,4.44,24.37-2.13,36C146.71,114.42,146.58,114.54,146.38,114.8Z",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,113.18h43.16c-.79,1.38-1.49,2.64-2.2,3.89-3,5.13-6,10.23-8.87,15.39a1.8,1.8,0,0,1-2.17,1.08C94.83,131.71,85,125.1,78.22,113.8,78.14,113.65,78.09,113.48,78,113.18Z",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,92.16c-3.91-6.77-7.67-13.32-11.47-19.83-.47-.8,0-1.24.35-1.75a38.94,38.94,0,0,1,23.45-15c3-.62,6-.77,9-1.13l.2.46Z",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.29,96.29c2,3.5,3.94,6.78,5.84,10.06s3.64,6.36,5.5,9.52a1.35,1.35,0,0,1,0,1.76,39.3,39.3,0,0,1-27.26,15.89c-1.4.17-2.81.19-4.22.28-.4,0-.79,0-1.49,0Z",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.53,111.08H80c-3.38,0-3.41,0-4.55-3.24a39.42,39.42,0,0,1,2.2-32.2c.34-.66.74-1.28,1.21-2.09Z",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.46,89.42A60.42,60.42,0,0,0,155,65.59c-12.36-22.17-37.82-37.35-68.18-27.5C74.22,42.16,69.86,47.15,67.07,50l7.39,11.85a49.92,49.92,0,0,1,9.4-8.63c1-.71,2-1.35,3-1.94a4.32,4.32,0,0,1,6,1.7l1.17,2.22a43.08,43.08,0,0,1,10.09-3.37,43.79,43.79,0,0,1,10.52-.79c14.72.72,25.22,9.63,26.29,10.56a44.27,44.27,0,0,1,14.62,28.89,43.09,43.09,0,0,1-72,35.42A44.18,44.18,0,0,1,73,111.08a43.08,43.08,0,0,1,3.21-40L72,65c-.49.67-1.12,1.6-1.82,2.73a50.63,50.63,0,0,0-5,10.69,50.18,50.18,0,0,0,5.53,42.94h0c10.75,18.94,28.74,36,37.22,43.44a6.89,6.89,0,0,0,9.24-.11c8.29-7.68,26-25.08,37.32-43.1.8-1.21,1.51-2.4,2.13-3.55l0,0h0a49.6,49.6,0,0,0,4-9.8A53.17,53.17,0,0,0,162.46,89.42Z",
    style: {
      fill: "#6038ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.86,53.25c1-.71,2-1.35,3-1.94a4.32,4.32,0,0,1,6,1.7l1.17,2.22a44,44,0,0,1,7.33-2.72A45.7,45.7,0,0,1,116.26,50c18.62,0,36.62,11.31,43.73,27.28a63.67,63.67,0,0,0-5-11.72c-12.36-22.17-37.82-37.35-68.18-27.5C74.22,42.16,69.86,47.15,67.07,50l7.39,11.85A49.92,49.92,0,0,1,83.86,53.25Z",
    style: {
      fill: "#7d3cbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.26,50a47.29,47.29,0,0,0-13.58,2.17c8.63-2,21.34-2.54,36.46,5.69C152.28,65,156.3,69.88,160,77.41,152.81,61.55,134.79,50,116.26,50Z",
    style: {
      fill: "#462791"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricetracqLogo);
export default __webpack_public_path__ + "static/media/pricetracq-logo.c15435baf3548ff42c61eb245d3c20f3.svg";
export { ForwardRef as ReactComponent };